import React from 'react';

export default function PostTitle({ children }) {
  return <h2 className="mb-2">{children}</h2>;
}
